<template>
  <div class="d-flex py-2 mr-2 text-center border-bottom-bloco">
    <span class="mr-n4" :class="{'text-gray-200': data_table_departamentos_carregando_dados}">R$</span>

    <InputFormatadorDeValor
      v-model="linha.preco_custo"
      :removerValorIrrelevante="true"
      centralizar
      class="font-12"
      :disabled="data_table_departamentos_carregando_dados"
      @focus="$event.target.select()"
      @blur="salvarEdicaoPreco"
      @keyup.enter="$event.target.blur()"
      @keydown.prevent.up="incrementarSugestao"
      @keydown.prevent.down="decrementarSugestao"
      @click.stop
    />

    <v-tooltip v-if="linha.preco_custo <= 0" bottom>
      <template v-slot:activator="{on, attrs}">
        <v-btn icon small color="red" v-bind="attrs" v-on="on">
          <v-icon>mdi-alert</v-icon>
        </v-btn>
      </template>
      <span>Preço de custo do produto inválido</span>
    </v-tooltip>
  </div>
</template>

<script>
import InputFormatadorDeValor from "../../../../utils/InputFormatadorDeValor.vue";

import {editarCategoriaNoPedido} from "../../../../../api/compraPorDepartamentos/ProdutosPedidoCompraTipo.js";

import {data_table_departamentos_carregando_dados} from "../../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";
import {NIVEIS_DE_EXPANCAO} from "../../../../utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao.js";

export default {
  name: "PrecoDeCusto",
  mixins: [data_table_departamentos_carregando_dados],
  components: {
    InputFormatadorDeValor
  },
  props: {
    linha: {
      type: Object,
      required: true
    },
    soma_niveis_menores: Number
  },
  data: () => ({
    NIVEIS_DE_EXPANCAO,
    preco_alterado: false
  }),
  watch: {
    'linha.preco_custo': {
      handler() {
        this.preco_alterado = true;
      }
    }
  },
  methods: {
    salvarEdicaoPreco() {
      if (!this.preco_alterado || this.linha.preco_custo <= 0) return;

      const categoria = {
        idcategoria: this.linha.idcategoria,
        id_pedido: this.linha.id_pedido,
        preco_custo: this.linha.preco_custo
      };

      this.$store.dispatch("loading/addRequisicao",
        editarCategoriaNoPedido(categoria).then(this.salvoComSucesso));
    },
    salvoComSucesso() {
      this.preco_alterado = false;
    },
    incrementarSugestao() {
      this.linha.preco_custo++;
    },
    decrementarSugestao() {
      this.linha.preco_custo--;
    }
  }
}
</script>

<style scoped>
.border-bottom-bloco {
  border-bottom: 1px solid #A9A9A9;
}
</style>
